import { DropdownAttribute, SEARCH_TYPES } from '@/components/Form/AudienceTargeting/Audience/interfaces'

import Aggregate from './Aggregate'
import CollectionEmailsSearch from './CollectionEmailsSearch'
import Search from './Search'

export const getSearchHandlerFromType = (searchType: DropdownAttribute['type']) => {
  switch (searchType) {
    case SEARCH_TYPES.search: {
      return Search
    }
    case SEARCH_TYPES.aggregate: {
      return Aggregate
    }
    case SEARCH_TYPES.collectionEmailsSearch: {
      return CollectionEmailsSearch
    }
    default: {
      return Search
    }
  }
}
